import React from "react";
import styled from "styled-components";
import { Icon } from ".";
import { StatusEnum } from "../../store/users/models/internal";
import { colours } from "../../styles/colours";
import { WIDGET_BORDER_RADIUS } from "../widget";

const StyledIcon = styled(Icon)`
  border-radius: ${WIDGET_BORDER_RADIUS};
`;

const kycIconMap: Record<StatusEnum, React.ReactElement<typeof StyledIcon>> = {
  DECLINED: (
    <StyledIcon
      type="kycDeclined"
      colour1={colours.white}
      colour2={colours.red}
    />
  ),
  VERIFIED: (
    <StyledIcon
      type="kycApproved"
      colour1={colours.white}
      colour2={colours.green}
    />
  ),
  FAILED: (
    <StyledIcon
      type="kycFailed"
      colour1={colours.white}
      colour2={colours.red}
    />
  ),
  DELETED: (
    <StyledIcon
      type="kycNotPerformed"
      colour1={colours.white}
      colour2={colours.darkGrey}
    />
  ),
  NA: (
    <StyledIcon
      type="kycNotPerformed"
      colour1={colours.white}
      colour2={colours.darkGrey}
    />
  ),
  PENDING: (
    <StyledIcon
      type="kycPending"
      colour1={colours.white}
      colour2={colours.darkGrey}
    />
  ),
  NOT_VERIFIED: (
    <StyledIcon
      type="kycNotVerified"
      colour1={colours.white}
      colour2={colours.darkGrey}
    />
  ),
  NOT_FOUND: (
    <StyledIcon
      type="kycNotFound"
      colour1={colours.white}
      colour2={colours.darkGrey}
    />
  ),
  FOUND: (
    <StyledIcon
      type="kycFound"
      colour1={colours.white}
      colour2={colours.darkGrey}
    />
  ),
  IN_REVIEW: (
    <StyledIcon
      type="kycInReview"
      colour1={colours.black}
      colour2={colours.yellow}
    />
  ),
};

const kybIconMap: Record<StatusEnum, React.ReactElement<typeof StyledIcon>> = {
  DECLINED: (
    <StyledIcon
      type="kybDeclined"
      colour1={colours.white}
      colour2={colours.red}
    />
  ),
  VERIFIED: (
    <StyledIcon
      type="kybApproved"
      colour1={colours.white}
      colour2={colours.green}
    />
  ),
  FAILED: (
    <StyledIcon
      type="kybFailed"
      colour1={colours.white}
      colour2={colours.red}
    />
  ),
  DELETED: (
    <StyledIcon
      type="kybNotPerformed"
      colour1={colours.white}
      colour2={colours.darkGrey}
    />
  ),
  NA: (
    <StyledIcon
      type="kybNotPerformed"
      colour1={colours.white}
      colour2={colours.darkGrey}
    />
  ),
  PENDING: (
    <StyledIcon
      type="kybPending"
      colour1={colours.white}
      colour2={colours.darkGrey}
    />
  ),
  NOT_VERIFIED: (
    <StyledIcon
      type="kybNotVerified"
      colour1={colours.white}
      colour2={colours.darkGrey}
    />
  ),
  NOT_FOUND: (
    <StyledIcon
      type="kybNotFound"
      colour1={colours.white}
      colour2={colours.blueGrey}
    />
  ),
  FOUND: (
    <StyledIcon
      type="kybFound"
      colour1={colours.white}
      colour2={colours.blueGrey}
    />
  ),
  IN_REVIEW: (
    <StyledIcon
      type="kybInReview"
      colour1={colours.black}
      colour2={colours.yellow}
    />
  ),
};

const amlIconMap: Record<StatusEnum, React.ReactElement<typeof StyledIcon>> = {
  DECLINED: (
    <StyledIcon
      type="amlDeclined"
      colour1={colours.white}
      colour2={colours.red}
    />
  ),
  VERIFIED: (
    <StyledIcon
      type="amlApproved"
      colour1={colours.white}
      colour2={colours.green}
    />
  ),
  FAILED: (
    <StyledIcon
      type="amlFailed"
      colour1={colours.white}
      colour2={colours.red}
    />
  ),
  DELETED: (
    <StyledIcon
      type="amlNotPerformed"
      colour1={colours.white}
      colour2={colours.darkGrey}
    />
  ),
  NA: (
    <StyledIcon
      type="amlNotPerformed"
      colour1={colours.white}
      colour2={colours.darkGrey}
    />
  ),
  PENDING: (
    <StyledIcon
      type="amlPending"
      colour1={colours.white}
      colour2={colours.darkGrey}
    />
  ),
  NOT_VERIFIED: (
    <StyledIcon
      type="amlNotVerified"
      colour1={colours.white}
      colour2={colours.darkGrey}
    />
  ),
  NOT_FOUND: (
    <StyledIcon
      type="amlNotFound"
      colour1={colours.white}
      colour2={colours.blueGrey}
    />
  ),
  FOUND: (
    <StyledIcon
      type="amlFound"
      colour1={colours.white}
      colour2={colours.blueGrey}
    />
  ),
  IN_REVIEW: (
    <StyledIcon
      type="amlInReview"
      colour1={colours.black}
      colour2={colours.yellow}
    />
  ),
};

const iconShortMap: Record<
  StatusEnum,
  React.ReactElement<typeof StyledIcon>
> = {
  DECLINED: (
    <StyledIcon
      type="kycFailedShort"
      colour2={colours.white}
      colour1={colours.red}
    />
  ),
  VERIFIED: (
    <StyledIcon
      type="kycApprovedShort"
      colour2={colours.white}
      colour1={colours.green}
    />
  ),
  FAILED: (
    <StyledIcon
      type="kycFailedShort"
      colour2={colours.white}
      colour1={colours.red}
    />
  ),
  DELETED: (
    <StyledIcon
      type="kycNotPerformedShort"
      colour2={colours.white}
      colour1={colours.darkGrey}
    />
  ),
  NA: (
    <StyledIcon
      type="kycNotPerformedShort"
      colour2={colours.white}
      colour1={colours.darkGrey}
    />
  ),
  PENDING: (
    <StyledIcon
      type="kycNotPerformedShort"
      colour2={colours.white}
      colour1={colours.darkGrey}
    />
  ),
  IN_REVIEW: (
    <StyledIcon
      type="kycNotPerformedShort"
      colour2={colours.white}
      colour1={colours.yellow}
    />
  ),
  NOT_VERIFIED: (
    <StyledIcon
      type="kycNotPerformedShort"
      colour2={colours.white}
      colour1={colours.darkGrey}
    />
  ),
  NOT_FOUND: (
    <StyledIcon
      type="kycFailedShort"
      colour2={colours.white}
      colour1={colours.blueGrey}
    />
  ),
  FOUND: (
    <StyledIcon
      type="kycApprovedShort"
      colour2={colours.white}
      colour1={colours.blueGrey}
    />
  ),
};

export const KycIcon: (
  status: StatusEnum,
  type: "aml" | "kyb" | "kyc",
  short?: boolean
) => React.ReactElement<typeof StyledIcon> = (
  status: StatusEnum,
  type,
  short
) => {
  if (short) return iconShortMap[status];
  switch (type) {
    case "aml":
      return amlIconMap[status];
    case "kyc":
      return kycIconMap[status];
    default:
      return kybIconMap[status];
  }
};
